<template>
    <f7-page id="account-fx-alert" name="account-fx-alert" class="bg-color-white" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <div class="block">
            <div class="fw-bold fs-24 mb-md">{{ $t('fx-alert-title') }}</div>
            <p class="text-color-gray m-0 fs-14">{{ $t('fx-alert-description') }}</p>

            <f7-list no-hairlines class="no-outlines color-gray7">
                <f7-list-item v-if="rateList.length == 0" class="bg-color-primary card">
                    <p class="text-center w-100 fw-medium fs-16 my-2 text-color-gray">{{$t('fx-alert-empty-rate')}}</p>
                </f7-list-item>

                <f7-list-item v-for="rate in rateList" :key="rate.id" class="list-content-row card">
                    <div class="w-100 ps-1">
                        <div class="d-flex fw-medium fs-12 mt-2 pt-1">
                            <div class="py-2 px-1 me-2 bg-color-green text-color-white d-flex-center segmented">
                                <img :src="getCircleSmallFlagImg(hostCurrency(rate).id)" class="mx-2" />
                                <span class="me-2">{{ hostCurrency(rate).code }}</span>
                            </div>
                            <img :src="require('@/assets/img/icon/icon-arrow-right.svg')" class="mx-1" />
                            <div class="py-2 px-1 ms-2 bg-color-green text-color-white d-flex-center segmented">
                                <img :src="getCircleSmallFlagImg(homeCurrency(rate).id)" class="mx-2" />
                                <span class="me-2">{{ homeCurrency(rate).code }}</span>
                            </div>
                        </div>
                        <p class="fw-medium fs-14 mt-2 pb-1 mb-2">{{$t('fx-alert-custom-list', {baseCCD: hostCurrency(rate).code, rate:formatAmount(rate), ccd:homeCurrency(rate).code})}}</p>
                    </div>
                    <img :src="require('@/assets/img/icon/trash.svg')" class="pointer px-1 py-2" @click="removeFxAlert(rate.id)"/>
                </f7-list-item>
            </f7-list>

            <f7-button class="mb-sm mt-xl" large fill @click="navigateToNextPage">
                {{$t('general-btn-create-text')}}
            </f7-button>
        </div>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { fxRateHelper as FX }  from '@/plugins/helper'

    export default {
        data() {
            return {
                rateList : [],
            }
        },
        methods: {
            ...mapActions('auth', ['login']),

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path});
                this.getFxAlert();
            },
            hostCurrency(rate) {
                return rate.baseCurrencyId == 189 ? {id: rate.baseCurrencyId, code: rate.baseCurrencyCode} : {id: rate.currencyId, code: rate.currencyCode}
            },
            homeCurrency(rate) {
                return rate.baseCurrencyId == 189 ? {id: rate.currencyId, code: rate.currencyCode} : {id: rate.baseCurrencyId, code: rate.baseCurrencyCode}
            },
            formatAmount(rate) {
                return FX.formatDisplayRate(rate.targetRate, {countryId: rate.currencyId, isDisplay: true});
            },
            async getFxAlert() {
                this.showPreloader();
                try {
                    const result = await this.$api.exchangeRate.getFXRateAlertList();
                    this.hidePreloader();
                    if(result === undefined || result.length <= 0) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        return false;
                    }

                    this.rateList = result;
                    if(!this.rateList || Object.keys(this.rateList).length == 0 || this.rateList == undefined) {
                        this.rateList = [];
                    }
                } catch(e){
                    this.hidePreloader();
                    if(e.message.toLowerCase().includes("undefined")) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    } else {
                        this.$f7.dialog.alert(e.message);
                    }
                }
            },
            async removeFxAlert(id) {
                this.showPreloader();
                try {
                    const result = await this.$api.exchangeRate.deleteFXRateAlert(id);
                    this.hidePreloader();
                    if(result === undefined || result.length <= 0) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        return false;
                    }

                    this.getFxAlert();
                } catch(e){
                    this.hidePreloader();
                    if(e.message.toLowerCase().includes("undefined")) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    } else {
                        this.$f7.dialog.alert(e.message);
                    }
                }
            },
            navigateToNextPage() {
                this.$f7router.navigate("/account/create-alert");
            },
            backButton() {
                this.$f7router.back({ transition: 'f7-push' });
            }
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ])
        }
    }
</script>